import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { OnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";

type ChangeOnboardingStatusRequest = {
  token: string;
  userId: string;
  onboardingStatus: OnboardingStatusEnum;
};

const changeOnboardingStatus = async ({
  token,
  userId,
  onboardingStatus,
}: ChangeOnboardingStatusRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/change-status/${userId}`,
      { onboardingStatus },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default changeOnboardingStatus;
